<template>
  <b-container fluid class="main-container p-0 vh-100">
    <router-view />
  </b-container>
</template>

<script>
export default {
  methods: {},
  beforeCreate() {
    this.$store.dispatch("session/loadCurrentUser");
    this.$store.dispatch("session/loadPatients");
    this.$store.dispatch("session/loadDocuments");
    this.$store.dispatch("appointments/loadAppointments");
    this.$store.dispatch("session/loadSystemSettings");
  }
};
</script>

<style lang="scss">
#app {
  font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main-container {
  background: #f5f6f9 !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.vs__clear {
  margin-bottom: 3px;
}
</style>
